import { FunctionComponent } from 'react';
import { TabItemProps } from './TabItemProps';

export const TabItem: FunctionComponent<TabItemProps> = ({ icon, title, tooltip, onClick }) => {
  return (
    <button className="pt-2 pb-1.5 px-2 rounded-lg hover:bg-black hover:bg-opacity-5" title={tooltip} onClick={onClick}>
      <div className="v-stack items-center space-y-1">
        <img className="w-5 h-5" src={icon} />
        <div className="text-tint text-sm font-medium">{title}</div>
      </div>
    </button>
  );
};
